import { createApp, defineAsyncComponent } from 'vue'
import App from '@/app/App.vue'
import directives from '@/app/providers/directives'
import UIComponents from '@/shared/ui'
import UIBaseComponents from '@/components/base'
import '@/shared/assets/tailwind.scss'
import '@/shared/lib/Prototypes'
import { createPinia } from 'pinia'
import router from '@/app/providers/router'
import i18n from "@/translate"
import vuetify from './plugins/vuetify'
import IconSvg from './shared/ui/IconSvg/IconSvg.vue'
import Maska from 'maska'
// @ts-ignore
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

import { http_client } from '@/plugins/httpClient'
import { backendHost, backendPath } from '@/app.config'

const pinia = createPinia()
const app = createApp(App)

if (process.env.NODE_ENV !== 'production') {
    // Отключение всех предупреждений Vue
    app.config.warnHandler = () => ({});
}

app.component(IconSvg.name, IconSvg);
UIComponents.forEach(UIComponentName => {
    app.component(
        UIComponentName.getAfterLast('/'),
        defineAsyncComponent(() => import(`@/shared/ui/${UIComponentName}.vue`))
    );
});

UIBaseComponents.forEach(UIComponentName => {
    app.component(
        UIComponentName.getAfterLast('/'),
        defineAsyncComponent(() => import(`@/components/base/${UIComponentName}.vue`))
    );
});

directives.forEach(directive => {
    app.directive(directive.name, directive);
});

app.use(router)
app.use(pinia)
app.use(vuetify)
app.use(Maska)
app.use(i18n)
app.use(VuePlyr, {
  plyr: {}, // Add Plyr options here if needed
});

app.use(http_client, {
	// baseUrl: process.env.VUE_APP__MODE === 'dev' ? `/${backendPath}` : `https://${backendHost}/${backendPath}`,
	baseUrl: process.env.VUE_APP__MODE === 'dev' ? `https://doc.doriclub.kz/api` : `/${backendPath}`,
})

app.mount('#app')
